import React from 'react';

import FormItem from './form-item';
import AffiliateSettings from './form-affiliate-settings';
import Icon from '../../ui/icon';

const FeedConfigurationAndTracking = (
  ftpName,
  setFtpName,
  ftpPassword,
  setFtpPassword,
  expectedFrequency,
  setExpectedFrequency,
  impressionTracker,
  setImpressionTracker,
  clickTracker,
  setClickTracker,
  logging,
  setLogging,
  feedEnabled,
  setFeedEnabled,
  utmParams,
  setUtmParams,
  defaultAffiliate,
  setDefaultAffiliate,
  affiliateTypes,
  linkmateAffiliate,
  setLinkmateAffiliate,
  notes,
  setNotes,
  lockFtpName,
  amazonConfig,
  setAmazonConfig,
  impactRadiusUrl,
  setImpactRadiusUrl,
  linkShareMemberId,
  setLinkShareMemberId,
  pmgUrl,
  setPmgUrl,
  skimLinkId,
  setSkimLinkId,
  vigilinkKey,
  setVigilinkKey,
  fieldErrors,
) => {
  const checkboxMap = [
    { value: logging, func: setLogging, label: 'Turn on logging' },
    { value: feedEnabled, func: setFeedEnabled, label: 'Feed enabled' },
  ];

  const ftpConfigInputs = [
    { value: ftpPassword, setter: setFtpPassword, label: 'FTP Password' },
    {
      value: expectedFrequency,
      setter: setExpectedFrequency,
      label: 'Expected Frequency (hrs)',
      className: 'Expected Frequency',
    },
  ];

  const clickTrackerCheckBoxes = checkboxMap.map(({ value, func, label }, idx) => {
    return (
      <div key={idx} className="checkbox-label pacing">
        <span
          className={`checkbox ${label.replace(/ /g, '-').toLowerCase()} ${
            value ? 'selected' : ''
          }`}
          onClick={() => func(!value)}
        ></span>
        <span className="checkbox-text">{label}</span>
      </div>
    );
  });

  const addParameter = () => setUtmParams([...utmParams, ['', '']]);

  const utmParamsFields = utmParams.map(([key, value], idx) => {
    const xBtn = idx ? (
      <div
        className="remove-utm"
        onClick={() => setUtmParams(utmParams.filter((param, index) => index !== idx))}
      >
        <Icon iconName="x" size={8} />
      </div>
    ) : null;

    return (
      <div key={idx} className="utm-input">
        <div className="utm-field">
          <span>Key</span>
          <input
            type="text"
            value={key}
            onChange={e => {
              const newParams = [...utmParams];
              newParams[idx][0] = e.target.value;
              setUtmParams(newParams);
            }}
          />
        </div>
        <div className="utm-field value">
          <span>Value</span>
          <input
            type="text"
            value={value}
            onChange={e => {
              const newParams = [...utmParams];
              newParams[idx][1] = e.target.value;
              setUtmParams(newParams);
            }}
          />
        </div>
        {xBtn}
      </div>
    );
  });

  const ftpConfigMap = ftpConfigInputs.map(({ value, setter, label, className }, idx) => (
    <FormItem key={idx} value={value} setter={setter} label={label} className={className} />
  ));

  const ftpNameField = lockFtpName ? (
    <div className="form-item">
      <label>FTP Name</label>
      <div className="prev-slug">{ftpName}</div>
    </div>
  ) : (
    <FormItem value={ftpName} setter={setFtpName} label="FTP Name" />
  );

  return (
    <div className="form">
      <div className="ftp-config">
        <div className="form-item">
          <label className="feed-config-header form-header">FTP Configuration</label>
        </div>
        {ftpNameField}
        {ftpConfigMap}
      </div>
      <div className="tracking">
        <div className="form-item">
          <label className="feed-config-header">Tracking</label>
        </div>
        <FormItem
          label="Impression Tracker"
          value={impressionTracker}
          setter={setImpressionTracker}
        />
        <div className="form-item click-tracker">
          <label>Click Tracker</label>
          <div className="auction-type">
            <input
              type="text"
              className="cogs-text"
              value={clickTracker}
              onChange={e => setClickTracker(e.target.value)}
            />
            <div className="click-tracker-checkboxes">{clickTrackerCheckBoxes}</div>
          </div>
        </div>
      </div>
      <div className="form-item utm-params">
        <label>UTM Parameters</label>
        <div className="auction-type">
          {utmParamsFields}
          <div className="add-param" onClick={addParameter}>
            + Add Parameter
          </div>
        </div>
      </div>
      <AffiliateSettings
        defaultAffiliate={defaultAffiliate}
        linkmateAffiliate={linkmateAffiliate}
        impactRadiusUrl={impactRadiusUrl}
        amazonConfig={amazonConfig}
        setAmazonConfig={setAmazonConfig}
        setImpactRadiusUrl={setImpactRadiusUrl}
        linkShareMemberId={linkShareMemberId}
        setLinkShareMemberId={setLinkShareMemberId}
        skimLinkId={skimLinkId}
        setSkimLinkId={setSkimLinkId}
        pmgUrl={pmgUrl}
        setPmgUrl={setPmgUrl}
        vigilinkKey={vigilinkKey}
        setVigilinkKey={setVigilinkKey}
        fieldErrors={fieldErrors}
        notes={notes}
        setNotes={setNotes}
        affiliateTypes={affiliateTypes}
        setDefaultAffiliate={setDefaultAffiliate}
        setLinkmateAffiliate={setLinkmateAffiliate}
      />
    </div>
  );
};

export default FeedConfigurationAndTracking;
